function Test(){
    return(
        <div>
            <h1>Test</h1>
        </div>
    )
}

export default Test;